import { svg } from "lit";
const icon = svg `<path d="M3.19052 15.2695L2.4165 14.4954L7.81392 9.09805L10.9806 12.2647L15.7418 7.54032H12.9998V6.45703H17.5831V11.0403H16.4998V8.31434L10.9806 13.8127L7.81392 10.6461L3.19052 15.2695Z" fill="currentColor"/>`;
export default icon;
